import { Route, Routes } from 'react-router-dom';
import PortalForm from '../pages/sys/PortalForm';
import InvoicePage from '../pages/sys/Invoice';
import PrintTableWithHeader from '../components/PrintReport';
import ActivityReport from '../pages/sys/ActivityReport';
import UserPermission from '../pages/users/UserPermission';
import QrCodeProfile from '../pages/sys/QrCodeProfile';
import MultiRowPrint from '../pages/caafi/MultiRowPrint';
import MultiRowPrintinv from '../pages/sys/MultiRowPrintInv';
import SummaryCategoryLetter from '../pages/caafi/Summary_category_letter';
import MaternityDeliveryNote from '../pages/caafi/DelivertNote';
import InvoiceBook from '../pages/web/KaafiPay/InvoiceBook';
import CancelReceipt from '../pages/aqoonkaal/CancelReceipt';
import CancelBusReceipt from '../pages/aqoonkaal/CancelBusReceipt';
import GenerateQrCode from '../pages/custom/GenerateQrCode';
import { ComplaintLetter } from '../components/ComplaintLetter';
import DetailCategoryLetter from '../pages/caafi/Detail_category_Letter';
import PosInvoice from '../pages/pos/PosInvoice';
import StudentReceiptInvoice2 from '../pages/aqoonkaal/ReceiptInvoice2';
import StudentReceiptInvoice from '../pages/aqoonkaal/ReceiptInvoice';
import ApiDocumentation from '../pages/sys/ApiDocumentation';
import { API_URL } from '../constants/api';
import SitCosInvoice from '../pages/pos/cityposinvoice';
import SalesPrint from '../pages/sys/SalesPrint';
import RegistrationLetter from '../pages/aqoonkaal/RegistrationLetter';
import PassCard from '../pages/aqoonkaal/PassCard';
import ClassPassCard from '../pages/aqoonkaal/ClassPassCard';
import ClassPassCard2 from '../pages/aqoonkaal/ClassPassCard2';
import PassCard2 from '../pages/aqoonkaal/Passcard2';
import Documentation from '../pages/sys/Documentation';
import SysFeatures from '../pages/sys/SysFeatures';
import ChartsPage from '../pages/custom/ChartsPage';
import { CustomInvoice } from '../pages/kaaliye/CustomInvoice';
import CustomRegistraionLetter from '../pages/aqoonkaal/CustomRegistrationLetter';

export const OtherRoutes = [
  <Route key="portal" path="/portal/:route" element={<PortalForm />} />,
  <Route key="invoice" path="/invoice/:route/:id" element={<InvoicePage />} />,
  <Route key="print" path="/print" element={<PrintTableWithHeader />} />,
  <Route
    key="print-activity"
    path="/print-activity"
    element={<ActivityReport />}
  />,
  <Route
    key="permission"
    path="/form-report/permission/:route"
    element={<UserPermission />}
  />,
  <Route key="qrcode" path="/qrcode/:route/:id" element={<QrCodeProfile />} />,
  <Route
    key="multiRowPrint"
    path="/multiRowPrint/:route/:id"
    element={<MultiRowPrint />}
  />,
  <Route
    key="multiRowPrintinv"
    path="/multiRowPrintinv/:route/:id"
    element={<MultiRowPrintinv />}
  />,
  <Route
    key="salesPrint"
    path="/salesPrint/:route/:id"
    element={<SalesPrint />}
  />,

  <Route
    key="detailCategoryLetter"
    path="/detailCategoryLetter/:route/:id"
    element={<DetailCategoryLetter />}
  />,
  <Route
    key="summaryCategoryLetter"
    path="/summaryCategoryLetter/:route/:id"
    element={<SummaryCategoryLetter />}
  />,
  <Route
    key="MaternityDeliveryNote"
    path="/MaternityDeliveryNote/:id"
    element={<MaternityDeliveryNote />}
  />,
  <Route key="invoice-book" path="/invoice-book" element={<InvoiceBook />} />,
  <Route
    key="cancel-receipt"
    path="/cancel-receipt/:fee_id/:ref_no"
    element={<CancelReceipt />}
  />,
  <Route
    key="cancel-bus-receipt"
    path="/cancel-bus-receipt/:fee_id/:ref_no"
    element={<CancelBusReceipt />}
  />,
  <Route key="qr-code" path="/qr-code" element={<GenerateQrCode />} />,
  <Route
    key="complaint-letter"
    path="/complaint-letter/:route/:id"
    element={<ComplaintLetter />}
  />,
  <Route
    key="pos-invoice"
    path="/pos-invoice/:route/:id"
    element={
      API_URL.includes('sitcoscollege') ? <SitCosInvoice /> : <PosInvoice />
    }
  />,
  <Route
    key="student-invoice1"
    path="/student-invoice/:route/:id"
    element={<StudentReceiptInvoice />}
  />,
  <Route
    key="student-invoice2"
    path="/student-invoice/:route/:fee_id/:id"
    element={<StudentReceiptInvoice2 />}
  />,
  <Route
    key="api-documentation"
    path="/api-documentation/:link_id"
    element={<ApiDocumentation />}
  />,
  <Route
    key="passcard"
    path="/passcard/:route/:id/:exam_id"
    element={<PassCard />}
  />,
  <Route
    key="passcard2"
    path="/passcard2/:route/:id/:exam_id"
    element={<PassCard2 />}
  />,
  <Route
    key="class-passcard"
    path="/class-passcard/:route/:class_id"
    element={<ClassPassCard />}
  />,
  <Route
    key="class-passcard2"
    path="/class-passcard2/:route/:class_id"
    element={<ClassPassCard2 />}
  />,
  <Route
    key="student-registration-letter"
    path="/registration-letter/:route/:id"
    element={<RegistrationLetter />}
  />,

  <Route
    key="documentation"
    path="/documentation/:_id/:type"
    element={<Documentation />}
  />,
  <Route
    key="sys-features"
    path="/sys-features/:_id/:type"
    element={<SysFeatures />}
  />,
  <Route
    key="dashboard-charts"
    path="/charts/:route"
    element={<ChartsPage />}
  />,
  <Route
    key="custom-invoice"
    path="/custom-invoice/:route/:ref_no"
    element={<CustomInvoice />}
  />,
  <Route
    key="custom-invoice"
    path="/student-letter/:route/:id"
    element={<CustomRegistraionLetter />}
  />,
];
